<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <QAutoComplete v-model="typefilter" :label="$t('servicesystem.common_objects.job.type')"
              :list="Object.values(eventTypes)" :textkey="'Name'" :valuekey="'Name'" multiple clearable externaledit
              class="ma-3">
            </QAutoComplete>
            <QDateTimeField3 v-model="startFilter" :label="$t('servicesystem.common_objects.commonterms.from')"
              placeholder="The beginning" clearable class="ma-3">
            </QDateTimeField3>
            <QDateTimeField3 v-model="endFilter" :label="$t('servicesystem.common_objects.commonterms.to')" clearable
              placeholder="Now" class="ma-3">
            </QDateTimeField3>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getEventLogListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="75" :pk="pk">

          <template v-slot:list-item="{ item }">
            <v-row no-gutters class="px-3 py-2">
              <v-col cols="auto" class="pr-3">
                <v-chip small :dark="eventTypeColor(item.Type) != ''" :color="eventTypeColor(item.Type)">
                  {{ item.Type }}
                </v-chip>
              </v-col>
              <v-col cols="0">
                {{ item.TimeStamp }}
              </v-col>
              <v-col cols="7">
                <v-card flat color="transparent" :class="item.open ? '' : 'compressedText'" tabindex="-1"
                  @click="toggleCollapse(item)">
                  {{ item.Text }}
                </v-card>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-btn icon small @click="copy(item)" tabindex="-1">
                  <v-icon size="14">mdi-content-copy</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import Vue from "vue";
import QDateTimeField3 from "@/components/Inputs/QDateTimeField3.vue";

export default {
  name: "AdminFailureCodes",
  props: {},
  components: {
    FilterPane,
    ListPane,
    Layout,
    QDateTimeField3,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ELL-",
      /*
      Event Viewer Mapped Levels
      In Windows Event Viewer, these correspond to the following Event Levels:

      Level	Event ID Level Value
      Critical	    1
      Error	        2
      Warning	      3
      Information	  4
      Verbose	      5

      These levels are part of the Windows Eventing system (ETW - Event Tracing for Windows), 
      and are also used when writing events using the EventLog.WriteEntry method or EventSource/EventLog classes in .NET.
      - GPT
      */
      eventTypes: {
        Critical: { Id: 1, Name: "Critical", Color: "error darken-3" },
        Error: { Id: 2, Name: "Error", Color: "error" },
        Warning: { Id: 3, Name: "Warning", Color: "tertiary" },
        Information: { Id: 4, Name: "Information", Color: "primary" },
        Verbose: { Id: 5, Name: "Verbose", Color: "disabled darken-4" },
      }
    };
  },

  mounted() { },

  methods: {
    eventTypeColor(type) {
      return this.eventTypes[type]?.Color || undefined;
    },

    toggleCollapse(item) { Vue.set(item, "open", !item.open); },

    copy(item) {
      //console.log(item.Text);
      navigator.clipboard.writeText(item.Text);
      return;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          TypeList: this.typefilter,
          Start: this.startFilter,
          End: this.endFilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    typefilter: {
      get() { return this.getQueryParam("filter-type", []); },
      set(update) { this.setQueryParam("filter-type", update); },
    },
    startFilter: {
      get() { return this.getQueryParam("filter-start", undefined); },
      set(update) { this.setQueryParam("filter-start", update); },
    },
    endFilter: {
      get() { return this.getQueryParam("filter-end", undefined); },
      set(update) { this.setQueryParam("filter-end", update); },
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.compressedText {
  overflow-wrap: break-word;
  line-clamp: 3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>